import { Lender, MerchantStructure } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { AddOrEditAgentInLenderContextCredentialsDialog } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInLenderContextTable/components/AddOrEditAgentInLenderContextCredentialsDialog/AddOrEditAgentInLenderContextCredentialsDialog';
import { AddOrEditAgentInSinglePaymentProviderCredentialsDialog } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInSinglePaymentProviderContextTable/components/AddOrEditAgentInSinglePaymentProviderCredentials/AddOrEditAgentInSinglePaymentProviderCredentials';
import { CredentialsType } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialsType';
interface AddCredentialsDialogProps {
  credentialsType: CredentialsType;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  agentId: string;
  channelId: string;
  lenders: Lender[];
  merchantStructure: MerchantStructure;
}
export const AddCredentialsDialogFactory = ({
  credentialsType,
  opened,
  setOpened,
  toggleDialog,
  agentId,
  channelId,
  lenders,
  merchantStructure,
}: AddCredentialsDialogProps) => {
  if (credentialsType === CredentialsType.AGENT_IN_LENDER_CONTEXT)
    return (
      <AddOrEditAgentInLenderContextCredentialsDialog
        lenders={lenders}
        opened={opened}
        setOpened={setOpened}
        toggleDialog={toggleDialog}
        agentId={agentId}
        channelId={channelId}
        merchantStructure={merchantStructure}
      />
    );
  if (credentialsType === CredentialsType.AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT)
    return (
      <AddOrEditAgentInSinglePaymentProviderCredentialsDialog
        agentId={agentId}
        opened={opened}
        setOpened={setOpened}
        toggleDialog={toggleDialog}
      />
    );
  return null;
};
